// removed by extract-text-webpack-plugin
module.exports = {"timer":"timer__13gQa","divider":"divider__1wZDr"};


//////////////////
// WEBPACK FOOTER
// ./components/countdown/styles/DetailCountdownTimer.scss
// module id = ihs+
// module chunks = 1